// Centralized feature registry for the UI.
// Keep keys in sync with backend feature flags.

export const features = Object.freeze({
    voice_enable: 'Enable phone voice conversations and VoiceBot configuration.',
    'chatbot.agent': 'Enable agent configuration in chatbots.',
    'chatbot.chatbot': 'Enable chatbot configuration in chatbots.',
    'chatbot.feedback': 'Enable feedback collection in chatbots.',
    'chatbot.suggestions': 'Enable initial suggestions in chatbots.',
    'chatbot.custom_header': 'Allow custom headers in the chatbot interface.',
    'chatbot.custom_placeholder': 'Allow custom placeholder text in the chatbot input field.',
    'chatbot.custom_footer': 'Allow custom footer text and URL in the chatbot interface.',
    'chatbot.live_agent': 'Enable live agent support for chatbots.',
    'chatbot.hide_powered_by': "Option to hide 'Powered by' branding in the chatbot interface.",
    'system.ticketing': 'Enable ticketing system for customer support.',
    'system.agent_requests': 'Enable agent requests feature.',
    'voiceflow.support': 'Enable Voiceflow integration for voice-based chatbots.',
    'nebot.support': 'Enable Nebot integration for chatbot development.',
});

// Historically referenced as `all_features` in app config.
export const all_features = Object.freeze(Object.keys(features));

// JS-friendly alias.
export const allFeatures = all_features;

// Permission vocabulary — mirrors PERMISSIONS in
// chatbot/app/security/permissions.py. One coarse permission per area.
export const permissions = Object.freeze({
    kb: 'Knowledge bases and documents.',
    conversations: 'Chatbot conversation history.',
    analytics: 'Analytics dashboards.',
    chatbots: 'Chatbot configuration.',
    agents: 'Agent configuration.',
    livechat: 'Live agent requests and live chat.',
    tickets: 'Internal and customer support tickets.',
    members: 'Client user management.',
    'admin.clients': 'Manage clients.',
    'admin.plans': 'Manage subscription plans.',
    'admin.permission_groups': 'Manage permission groups.',
    'admin.vector_stores': 'Manage vector stores.',
    'admin.tickets': 'Manage admin tickets.',
    'admin.help': 'Manage the help center.',
});

export const allPermissions = Object.freeze(Object.keys(permissions));

// Layout of the permission checkboxes on the Permission Groups admin page.
export const permissionGroups_layout = Object.freeze([
    { key: 'knowledge', permissions: ['kb', 'conversations', 'analytics'] },
    { key: 'engagement', permissions: ['livechat', 'chatbots', 'agents'] },
    { key: 'support', permissions: ['tickets', 'members'] },
    { key: 'admin', permissions: ['admin.clients', 'admin.plans', 'admin.permission_groups', 'admin.vector_stores', 'admin.tickets', 'admin.help'] },
]);
